jQuery(function ($) {
  var $area = $(".section-map .area");

  if ($area) {
    $area.on("mouseenter", function () {
      $(".field-map").addClass("hovering");
    });

    $area.on("mouseleave", function () {
      $(".field-map").removeClass("hovering");
    });
  }
});
